import { TotalEnergyCost } from './vehicleCost/energyCost/total-energy-cost.model';
import { FinancialsEnergy } from './vehicleCost/financials/financials-energy.model';
import { CountryEmissionFactor } from './vehicleCost/impactCo2/country-emission-factor.model';
import { EnergyTransportCost } from './vehicleCost/transport/energy-transport-cost.model';
import { EnergyIncentivesTax } from './vehicleCost/incentives/energy-incentive.model';

export class VehicleCost {
	id!: number;
	financials: FinancialsEnergy;
	energyCost!: TotalEnergyCost;
	energyIncentivesTaxe!: EnergyIncentivesTax;
	impactCo2: CountryEmissionFactor;
	transportCost!: EnergyTransportCost;
}
